import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unitNameTransform',
    standalone: false
})
export class UnitNameTransformPipe implements PipeTransform {
  transform(value: string): string {
    return value.split('_').join(' ');
  }
}
